(function () {
  'use strict';

  const DESKTOP_MIN = 1025;
  const TRANSITION_MS = 400;
  const SWIPE_THRESHOLD = 10;

  const cardStates = new WeakMap();
  let currentIsDesktop = isDesktop();
  let resizeTimer = null;

  function isDesktop() {
    if (typeof window.isPlpGalleryDesktopBreakpoint === 'function') {
      return window.isPlpGalleryDesktopBreakpoint();
    }
    return window.matchMedia('(min-width: ' + DESKTOP_MIN + 'px)').matches;
  }

  function getCards(container) {
    const root = container || document.getElementById('ProductGridContainer') || document;

    if (root.id === 'ProductGridContainer') {
      return root.querySelectorAll(
        '#product-grid .product-card-wrapper.plp-multi-image[data-plp-gallery], #product-grid .product-card-wrapper.plp-multi-image'
      );
    }

    return document.querySelectorAll(
      '.product-grid-container #product-grid .product-card-wrapper.plp-multi-image[data-plp-gallery], .product-grid-container #product-grid .product-card-wrapper.plp-multi-image'
    );
  }

  function resetInlineImageStyles(card) {
    const firstImage = card.querySelector('.product-first-image');
    const swiperWrapper = card.querySelector('.product-swiper-wrapper');
    if (firstImage) firstImage.style.removeProperty('display');
    if (swiperWrapper) swiperWrapper.style.removeProperty('display');
  }

  function showFirstImage(card) {
    if (isDesktop()) {
      card.classList.remove('plp-swiper-active');
      return;
    }
    const firstImage = card.querySelector('.product-first-image');
    const swiperWrapper = card.querySelector('.product-swiper-wrapper');
    if (firstImage) firstImage.style.display = 'block';
    if (swiperWrapper) swiperWrapper.style.display = 'none';
  }

  function showSwiper(card) {
    if (isDesktop()) return;
    const firstImage = card.querySelector('.product-first-image');
    const swiperWrapper = card.querySelector('.product-swiper-wrapper');
    if (firstImage) firstImage.style.display = 'none';
    if (swiperWrapper) swiperWrapper.style.display = 'block';
  }

  function getImageCount(card) {
    const swiperEl = card.querySelector('.product-card-swiper');
    if (!swiperEl) return 0;
    const count = parseInt(swiperEl.getAttribute('data-image-count'), 10);
    if (!isNaN(count) && count > 0) return count;
    return swiperEl.querySelectorAll('.swiper-slide').length;
  }

  function getStoredUserSlideIndex(card) {
    const stored = parseInt(card.getAttribute('data-plp-last-user-index'), 10);
    if (!isNaN(stored) && stored >= 0) return stored;
    return null;
  }

  function setStoredUserSlideIndex(card, index) {
    if (typeof index === 'number' && index >= 0) {
      card.setAttribute('data-plp-last-user-index', String(index));
    }
  }

  function updateMobileZoom(card, activeIndex) {
    const swiperEl = card.querySelector('.product-card-swiper');
    if (!swiperEl) return;
    if (activeIndex === 1) {
      swiperEl.classList.add('is-zoom-active');
    } else {
      swiperEl.classList.remove('is-zoom-active');
    }
  }

  function setupSwipeGuard(card, state) {
    const link = card.querySelector('a.full-unstyled-link');
    if (!link) return;

    const onTouchStart = function (e) {
      const touch = e.touches[0];
      state.touchStartX = touch.clientX;
      state.touchStartY = touch.clientY;
      state.isSwiping = false;
    };

    const onTouchMove = function (e) {
      const touch = e.touches[0];
      const dx = Math.abs(touch.clientX - state.touchStartX);
      const dy = Math.abs(touch.clientY - state.touchStartY);
      if (dx > SWIPE_THRESHOLD && dx > dy) {
        state.isSwiping = true;
      }
    };

    const onClick = function (e) {
      if (state.isSwiping) {
        e.preventDefault();
        e.stopPropagation();
        state.isSwiping = false;
      }
    };

    link.addEventListener('touchstart', onTouchStart, { passive: true });
    link.addEventListener('touchmove', onTouchMove, { passive: true });
    link.addEventListener('click', onClick, true);

    state.swipeGuard = { link: link, onTouchStart: onTouchStart, onTouchMove: onTouchMove, onClick: onClick };
  }

  function destroySwiperInstance(state) {
    if (state.swiper && !state.swiper.destroyed) {
      state.swiper.destroy(true, false);
    }
    state.swiper = null;
  }

  function cleanupSwiperElement(card) {
    const swiperEl = card.querySelector('.product-card-swiper');
    if (!swiperEl) return;

    swiperEl.classList.remove(
      'swiper-initialized',
      'swiper-horizontal',
      'swiper-android',
      'swiper-ios',
      'swiper-backface-hidden',
      'is-zoom-active'
    );

    const wrapper = swiperEl.querySelector('.swiper-wrapper');
    if (wrapper) {
      wrapper.removeAttribute('style');
      wrapper.querySelectorAll('.swiper-slide').forEach(function (slide) {
        slide.removeAttribute('style');
      });
    }
  }

  function createSwiper(card, options) {
    const swiperEl = card.querySelector('.product-card-swiper');
    if (!swiperEl || typeof Swiper === 'undefined') return null;

    if (swiperEl.swiper && !swiperEl.swiper.destroyed) {
      return swiperEl.swiper;
    }

    const imageCount = getImageCount(card);
    if (imageCount <= 1) return null;

    const scrollbarEl = swiperEl.querySelector('.swiper-scrollbar');
    const config = {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      allowTouchMove: !options.desktop,
      noSwiping: false,
      preventClicks: true,
      preventClicksPropagation: true,
      watchOverflow: true,
      resistanceRatio: 0.85,
      observer: true,
      observeParents: true
    };

    if (!options.desktop && scrollbarEl) {
      config.scrollbar = {
        el: scrollbarEl,
        draggable: true,
        hide: false
      };
      config.on = {
        init: function () {
          updateMobileZoom(card, this.activeIndex);
        },
        slideChange: function () {
          const previousIndex = this.previousIndex;
          const index = this.activeIndex;
          updateMobileZoom(card, index);
          setStoredUserSlideIndex(card, index);

          if (index !== previousIndex && typeof window.handlePlpProductImageSwipe === 'function') {
            window.handlePlpProductImageSwipe(card, index + 1);
          }
        }
      };
    }

    if (typeof window.bindPlpGalleryTouchIsolation === 'function') {
      window.bindPlpGalleryTouchIsolation(swiperEl);
    }

    return new Swiper(swiperEl, config);
  }

  function destroyCardState(card) {
    const state = cardStates.get(card);
    if (!state) {
      card.removeAttribute('data-plp-swiper-init');
      resetInlineImageStyles(card);
      card.classList.remove('plp-swiper-active');
      const orphanSwiperEl = card.querySelector('.product-card-swiper');
      if (orphanSwiperEl) {
        if (orphanSwiperEl.swiper && !orphanSwiperEl.swiper.destroyed) {
          orphanSwiperEl.swiper.destroy(true, false);
        }
        orphanSwiperEl.classList.remove('is-zoom-active');
        cleanupSwiperElement(card);
      }
      return;
    }

    if (state.destroyTimer) {
      clearTimeout(state.destroyTimer);
      state.destroyTimer = null;
    }

    if (state.handlers) {
      card.removeEventListener('pointerenter', state.handlers.onEnter);
      card.removeEventListener('pointerleave', state.handlers.onLeave);
      card.removeEventListener('mouseenter', state.handlers.onEnter);
      card.removeEventListener('mouseleave', state.handlers.onLeave);
    }

    if (state.swipeGuard) {
      const guard = state.swipeGuard;
      guard.link.removeEventListener('touchstart', guard.onTouchStart);
      guard.link.removeEventListener('touchmove', guard.onTouchMove);
      guard.link.removeEventListener('click', guard.onClick, true);
    }

    destroySwiperInstance(state);
    cleanupSwiperElement(card);
    card.classList.remove('plp-swiper-active');
    const activeSwiperEl = card.querySelector('.product-card-swiper');
    if (activeSwiperEl) activeSwiperEl.classList.remove('is-zoom-active');
    card.removeAttribute('data-plp-swiper-init');
    resetInlineImageStyles(card);
    cardStates.delete(card);
  }

  function initDesktopHover(card, state) {
    const onEnter = function (e) {
      if (e && e.pointerType && e.pointerType !== 'mouse') return;

      if (state.destroyTimer) {
        clearTimeout(state.destroyTimer);
        state.destroyTimer = null;
      }

      card.classList.add('plp-swiper-active');

      if (!state.swiper || state.swiper.destroyed) {
        state.swiper = createSwiper(card, { desktop: true });
      }

      if (state.swiper) {
        const stored = getStoredUserSlideIndex(card);
        const targetIndex = stored !== null && stored >= 1 ? stored : 1;
        const previousIndex = state.swiper.activeIndex;
        state.swiper.slideTo(targetIndex, 0);
        const swiperEl = card.querySelector('.product-card-swiper');
        if (swiperEl && targetIndex === 1) {
          swiperEl.classList.add('is-zoom-active');
        } else if (swiperEl) {
          updateMobileZoom(card, targetIndex);
        }
        if (
          targetIndex !== previousIndex &&
          targetIndex >= 1 &&
          typeof window.handlePlpProductImageHover === 'function'
        ) {
          window.handlePlpProductImageHover(card, targetIndex + 1);
        }
      }
    };

    const onLeave = function (e) {
      if (e && e.pointerType && e.pointerType !== 'mouse') return;

      card.classList.remove('plp-swiper-active');
      const swiperEl = card.querySelector('.product-card-swiper');
      if (swiperEl) swiperEl.classList.remove('is-zoom-active');

      if (state.swiper && !state.swiper.destroyed) {
        state.swiper.slideTo(0, 0);
      }

      state.destroyTimer = setTimeout(function () {
        destroySwiperInstance(state);
        state.destroyTimer = null;
      }, TRANSITION_MS);
    };

    card.addEventListener('pointerenter', onEnter);
    card.addEventListener('pointerleave', onLeave);
    state.handlers = { onEnter: onEnter, onLeave: onLeave };
  }

  function initMobileCard(card, state) {
    showSwiper(card);
    state.swiper = createSwiper(card, { desktop: false });

    if (!state.swiper) {
      showFirstImage(card);
      return false;
    }

    setupSwipeGuard(card, state);
    state.swiper.update();
    return true;
  }

  function fallbackUninitializedMobileCards(container) {
    if (isDesktop()) return;

    getCards(container).forEach(function (card) {
      if (card.getAttribute('data-plp-swiper-init') === 'true') return;
      showFirstImage(card);
    });
  }

  function initCard(card) {
    if (card.getAttribute('data-plp-swiper-init') === 'true') {
      const existingState = cardStates.get(card);
      if (!isDesktop() && existingState && existingState.swiper && !existingState.swiper.destroyed) {
        return;
      }
      if (isDesktop() && existingState && existingState.handlers) {
        return;
      }
      destroyCardState(card);
    }

    if (!card.classList.contains('plp-multi-image')) return;
    if (!card.hasAttribute('data-plp-gallery') && getImageCount(card) <= 1) return;
    if (getImageCount(card) <= 1) return;

    resetInlineImageStyles(card);

    const state = {};
    cardStates.set(card, state);

    if (isDesktop()) {
      initDesktopHover(card, state);
      card.setAttribute('data-plp-swiper-init', 'true');
      return;
    }

    initMobileCard(card, state);

    if (!state.swiper) {
      cardStates.delete(card);
      card.removeAttribute('data-plp-swiper-init');
      return;
    }

    card.setAttribute('data-plp-swiper-init', 'true');
  }

  function reinitOnBreakpointChange() {
    const container = document.getElementById('ProductGridContainer') || document;
    const cards = getCards(container);
    cards.forEach(destroyCardState);
    window.initializeProductCardSwipers(container);
  }

  window.initializeProductCardSwipers = function (container) {
    if (typeof Swiper === 'undefined') return;

    const cards = getCards(container);
    cards.forEach(initCard);
  };

  window.initPlpProductCardsInContainer = function (container) {
    window.initializeProductCardSwipers(container);
  };

  window.resetProductCardSwipers = function (container) {
    const cards = getCards(container);
    cards.forEach(destroyCardState);

    const productGrid = document.getElementById('product-grid');
    if (productGrid) {
      productGrid.style.removeProperty('z-index');
      productGrid.style.removeProperty('position');
    }
  };

  window.scheduleInitializeProductCardSwipers = function (container) {
    const root = container || document.getElementById('ProductGridContainer') || document;
    let attempts = 0;
    const maxAttempts = 20;

    function tryInit() {
      if (typeof Swiper !== 'undefined' && typeof window.initializeProductCardSwipers === 'function') {
        window.initializeProductCardSwipers(root);
        return true;
      }
      return false;
    }

    if (!tryInit()) {
      const intervalId = setInterval(function () {
        attempts++;
        if (tryInit() || attempts >= maxAttempts) {
          clearInterval(intervalId);
          if (attempts >= maxAttempts) {
            fallbackUninitializedMobileCards(root);
          }
        }
      }, 50);
    }

    requestAnimationFrame(function () {
      tryInit();
    });

    setTimeout(function () {
      tryInit();
      fallbackUninitializedMobileCards(root);
    }, 150);
  };

  function onReady() {
    const plpGrid = document.getElementById('ProductGridContainer');
    if (!plpGrid) return;
    window.initializeProductCardSwipers(plpGrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', function () {
    const plpGrid = document.getElementById('ProductGridContainer');
    if (plpGrid) window.initializeProductCardSwipers(plpGrid);
  });

  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      const newIsDesktop = isDesktop();
      if (newIsDesktop !== currentIsDesktop) {
        currentIsDesktop = newIsDesktop;
        reinitOnBreakpointChange();
      }
    }, 150);
  });

  if (window.mediaQueryPlpGalleryDesktop && typeof window.mediaQueryPlpGalleryDesktop.addEventListener === 'function') {
    window.mediaQueryPlpGalleryDesktop.addEventListener('change', function () {
      const newIsDesktop = isDesktop();
      if (newIsDesktop !== currentIsDesktop) {
        currentIsDesktop = newIsDesktop;
        reinitOnBreakpointChange();
      }
    });
  }
})();
